



import LiveCreateComponent from "@/components/admin/live/liveCreateComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "LiveCreatePage",
  components: {
    LiveCreateComponent,
  },
})
export default class LiveCreatePage extends Vue {}
